import Dexie from 'dexie';
import { cloneDeep } from 'lodash';

/**
 * Quickly initialise a dexie database for storing page states.
 */
export const dexieStore = new Dexie('sourceflow_page_builder_states');

dexieStore.version(1).stores({
  pageStates: '++dataStateIndex,data',
});

export const clearDexieStore = async () => {
  try {
    await dexieStore.pageStates.clear();
  } catch (error) {
    console.error('[SFPB - DEXIE] Error clearing Dexie:', error);
  }
};

export const storeToDexie = async (dataStateIndex, data) => {
  try {
    const serialisableData = cloneDeep(data);

    await dexieStore.pageStates.put({
      dataStateIndex,
      data: serialisableData,
    });
  } catch (error) {
    console.error('[SFPB - DEXIE] Error saving state to Dexie:', error);
  }
};

export const createDexieHistoryEntry = (state) => {
  const nextIndex = state.currentDataStateIndex + 1;
  state.currentDataStateIndex = nextIndex;
  state.totalDataStateIndex = nextIndex;

  storeToDexie(nextIndex, state.data);
};

export const getDexieHistoryEntry = async (dataStateIndex) => {
  try {
    const entry = await dexieStore.pageStates.get(dataStateIndex);
    return entry ? entry : null;
  } catch (error) {
    console.error('[SFPB - DEXIE] Error retrieving state from Dexie:', error);
    return null;
  }
};
